import { Platform, StyleSheet } from 'react-native';

export default StyleSheet.create({
  instructions: {
    fontSize: 14,
    fontWeight: '600',
    textAlign: 'left',
    width: '100%',
  },
  textAreaContainer: {
    position: 'relative',
    width: '100%',
    marginVertical: 24,
    borderRadius: 6,
    flex: 1,
    borderWidth: 1,
    minHeight: 150,
    maxHeight: 300,
    paddingHorizontal: 16,
    paddingTop: 12,
    paddingBottom: 8,
  },
  textArea: {
    width: '100%',
    flex: 1,
    borderWidth: 0,
    fontSize: 17,
    ...Platform.select({ web: { outlineWidth: 0 } }),
  },
  charactersLeft: {
    textAlign: 'right',
    fontSize: 12,
  },
});
